export default "__VITE_ASSET__DLqpGbav__"